import * as Types from './types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type ThemeDetailFragment = { __typename?: 'Theme', id: string, name: string, environmentId: string, payload: unknown, created: string, updated: string, isDefault?: boolean | null, streamContainers: { __typename?: 'StreamContainersConnection', totalCount: number }, streamContainersByDarkThemeId: { __typename?: 'StreamContainersConnection', totalCount: number } };

export type ThemeListQueryVariables = Types.Exact<{
  environmentId: Types.Scalars['String']['input'];
  orderBy?: Array<Types.ThemesOrderBy> | Types.ThemesOrderBy;
}>;


export type ThemeListQuery = { __typename?: 'Query', themes?: { __typename?: 'ThemesConnection', totalCount: number, nodes: Array<{ __typename?: 'Theme', id: string, name: string, environmentId: string, payload: unknown, created: string, updated: string, isDefault?: boolean | null, streamContainers: { __typename?: 'StreamContainersConnection', totalCount: number }, streamContainersByDarkThemeId: { __typename?: 'StreamContainersConnection', totalCount: number } }> } | null };

export type GetThemeQueryVariables = Types.Exact<{
  id: Types.Scalars['String']['input'];
  environmentId: Types.Scalars['String']['input'];
}>;


export type GetThemeQuery = { __typename?: 'Query', theme?: { __typename?: 'Theme', id: string, name: string, environmentId: string, payload: unknown, created: string, updated: string, isDefault?: boolean | null, streamContainers: { __typename?: 'StreamContainersConnection', totalCount: number }, streamContainersByDarkThemeId: { __typename?: 'StreamContainersConnection', totalCount: number } } | null };

export type AddThemeMutationVariables = Types.Exact<{
  environmentId: Types.Scalars['String']['input'];
  name: Types.Scalars['String']['input'];
  payload: Types.Scalars['JSON']['input'];
}>;


export type AddThemeMutation = { __typename?: 'Mutation', createTheme?: { __typename?: 'CreateThemePayload', theme?: { __typename?: 'Theme', id: string, name: string, environmentId: string, payload: unknown, created: string, updated: string, isDefault?: boolean | null, streamContainers: { __typename?: 'StreamContainersConnection', totalCount: number }, streamContainersByDarkThemeId: { __typename?: 'StreamContainersConnection', totalCount: number } } | null } | null };

export type UpdateThemeMutationVariables = Types.Exact<{
  id: Types.Scalars['String']['input'];
  environmentId: Types.Scalars['String']['input'];
  name?: Types.InputMaybe<Types.Scalars['String']['input']>;
  payload?: Types.InputMaybe<Types.Scalars['JSON']['input']>;
}>;


export type UpdateThemeMutation = { __typename?: 'Mutation', updateTheme?: { __typename?: 'UpdateThemePayload', theme?: { __typename?: 'Theme', id: string, name: string, environmentId: string, payload: unknown, created: string, updated: string, isDefault?: boolean | null, streamContainers: { __typename?: 'StreamContainersConnection', totalCount: number }, streamContainersByDarkThemeId: { __typename?: 'StreamContainersConnection', totalCount: number } } | null } | null };

export type DeleteThemeMutationVariables = Types.Exact<{
  id: Types.Scalars['String']['input'];
  environmentId: Types.Scalars['String']['input'];
}>;


export type DeleteThemeMutation = { __typename?: 'Mutation', deleteTheme?: { __typename?: 'DeleteThemePayload', theme?: { __typename?: 'Theme', id: string, name: string, environmentId: string, payload: unknown, created: string, updated: string, isDefault?: boolean | null, streamContainers: { __typename?: 'StreamContainersConnection', totalCount: number }, streamContainersByDarkThemeId: { __typename?: 'StreamContainersConnection', totalCount: number } } | null } | null };

export type SetDefaultThemeMutationVariables = Types.Exact<{
  themeId: Types.Scalars['String']['input'];
  environmentId: Types.Scalars['String']['input'];
}>;


export type SetDefaultThemeMutation = { __typename?: 'Mutation', setDefaultTheme?: { __typename?: 'SetDefaultThemePayload', themes?: Array<{ __typename?: 'Theme', id: string, name: string, environmentId: string, payload: unknown, created: string, updated: string, isDefault?: boolean | null, streamContainers: { __typename?: 'StreamContainersConnection', totalCount: number }, streamContainersByDarkThemeId: { __typename?: 'StreamContainersConnection', totalCount: number } }> | null } | null };

export const ThemeDetailFragmentDoc = gql`
    fragment ThemeDetail on Theme {
  id
  name
  environmentId
  payload
  created
  updated
  isDefault
  streamContainers: streamContainersByEnvironmentIdAndThemeId {
    totalCount
  }
  streamContainersByDarkThemeId: streamContainersByEnvironmentIdAndDarkThemeId {
    totalCount
  }
}
    `;
export const ThemeListDocument = gql`
    query ThemeList($environmentId: String!, $orderBy: [ThemesOrderBy!]! = [NAME_ASC]) {
  themes(orderBy: $orderBy, condition: {environmentId: $environmentId}) {
    nodes {
      ...ThemeDetail
    }
    totalCount
  }
}
    ${ThemeDetailFragmentDoc}`;

/**
 * __useThemeListQuery__
 *
 * To run a query within a React component, call `useThemeListQuery` and pass it any options that fit your needs.
 * When your component renders, `useThemeListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useThemeListQuery({
 *   variables: {
 *      environmentId: // value for 'environmentId'
 *      orderBy: // value for 'orderBy'
 *   },
 * });
 */
export function useThemeListQuery(baseOptions: Apollo.QueryHookOptions<ThemeListQuery, ThemeListQueryVariables> & ({ variables: ThemeListQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ThemeListQuery, ThemeListQueryVariables>(ThemeListDocument, options);
      }
export function useThemeListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ThemeListQuery, ThemeListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ThemeListQuery, ThemeListQueryVariables>(ThemeListDocument, options);
        }
export function useThemeListSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ThemeListQuery, ThemeListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ThemeListQuery, ThemeListQueryVariables>(ThemeListDocument, options);
        }
export type ThemeListQueryHookResult = ReturnType<typeof useThemeListQuery>;
export type ThemeListLazyQueryHookResult = ReturnType<typeof useThemeListLazyQuery>;
export type ThemeListSuspenseQueryHookResult = ReturnType<typeof useThemeListSuspenseQuery>;
export type ThemeListQueryResult = Apollo.QueryResult<ThemeListQuery, ThemeListQueryVariables>;
export const GetThemeDocument = gql`
    query GetTheme($id: String!, $environmentId: String!) {
  theme(id: $id, environmentId: $environmentId) {
    ...ThemeDetail
  }
}
    ${ThemeDetailFragmentDoc}`;

/**
 * __useGetThemeQuery__
 *
 * To run a query within a React component, call `useGetThemeQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetThemeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetThemeQuery({
 *   variables: {
 *      id: // value for 'id'
 *      environmentId: // value for 'environmentId'
 *   },
 * });
 */
export function useGetThemeQuery(baseOptions: Apollo.QueryHookOptions<GetThemeQuery, GetThemeQueryVariables> & ({ variables: GetThemeQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetThemeQuery, GetThemeQueryVariables>(GetThemeDocument, options);
      }
export function useGetThemeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetThemeQuery, GetThemeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetThemeQuery, GetThemeQueryVariables>(GetThemeDocument, options);
        }
export function useGetThemeSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetThemeQuery, GetThemeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetThemeQuery, GetThemeQueryVariables>(GetThemeDocument, options);
        }
export type GetThemeQueryHookResult = ReturnType<typeof useGetThemeQuery>;
export type GetThemeLazyQueryHookResult = ReturnType<typeof useGetThemeLazyQuery>;
export type GetThemeSuspenseQueryHookResult = ReturnType<typeof useGetThemeSuspenseQuery>;
export type GetThemeQueryResult = Apollo.QueryResult<GetThemeQuery, GetThemeQueryVariables>;
export const AddThemeDocument = gql`
    mutation AddTheme($environmentId: String!, $name: String!, $payload: JSON!) {
  createTheme(
    input: {theme: {name: $name, environmentId: $environmentId, payload: $payload}}
  ) {
    theme {
      ...ThemeDetail
    }
  }
}
    ${ThemeDetailFragmentDoc}`;

/**
 * __useAddThemeMutation__
 *
 * To run a mutation, you first call `useAddThemeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddThemeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addThemeMutation, { data, loading, error }] = useAddThemeMutation({
 *   variables: {
 *      environmentId: // value for 'environmentId'
 *      name: // value for 'name'
 *      payload: // value for 'payload'
 *   },
 * });
 */
export function useAddThemeMutation(baseOptions?: Apollo.MutationHookOptions<AddThemeMutation, AddThemeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddThemeMutation, AddThemeMutationVariables>(AddThemeDocument, options);
      }
export type AddThemeMutationHookResult = ReturnType<typeof useAddThemeMutation>;
export type AddThemeMutationResult = Apollo.MutationResult<AddThemeMutation>;
export type AddThemeMutationOptions = Apollo.BaseMutationOptions<AddThemeMutation, AddThemeMutationVariables>;
export const UpdateThemeDocument = gql`
    mutation UpdateTheme($id: String!, $environmentId: String!, $name: String, $payload: JSON) {
  updateTheme(
    input: {id: $id, environmentId: $environmentId, patch: {name: $name, payload: $payload}}
  ) {
    theme {
      ...ThemeDetail
    }
  }
}
    ${ThemeDetailFragmentDoc}`;

/**
 * __useUpdateThemeMutation__
 *
 * To run a mutation, you first call `useUpdateThemeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateThemeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateThemeMutation, { data, loading, error }] = useUpdateThemeMutation({
 *   variables: {
 *      id: // value for 'id'
 *      environmentId: // value for 'environmentId'
 *      name: // value for 'name'
 *      payload: // value for 'payload'
 *   },
 * });
 */
export function useUpdateThemeMutation(baseOptions?: Apollo.MutationHookOptions<UpdateThemeMutation, UpdateThemeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateThemeMutation, UpdateThemeMutationVariables>(UpdateThemeDocument, options);
      }
export type UpdateThemeMutationHookResult = ReturnType<typeof useUpdateThemeMutation>;
export type UpdateThemeMutationResult = Apollo.MutationResult<UpdateThemeMutation>;
export type UpdateThemeMutationOptions = Apollo.BaseMutationOptions<UpdateThemeMutation, UpdateThemeMutationVariables>;
export const DeleteThemeDocument = gql`
    mutation DeleteTheme($id: String!, $environmentId: String!) {
  deleteTheme(input: {id: $id, environmentId: $environmentId}) {
    theme {
      ...ThemeDetail
    }
  }
}
    ${ThemeDetailFragmentDoc}`;

/**
 * __useDeleteThemeMutation__
 *
 * To run a mutation, you first call `useDeleteThemeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteThemeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteThemeMutation, { data, loading, error }] = useDeleteThemeMutation({
 *   variables: {
 *      id: // value for 'id'
 *      environmentId: // value for 'environmentId'
 *   },
 * });
 */
export function useDeleteThemeMutation(baseOptions?: Apollo.MutationHookOptions<DeleteThemeMutation, DeleteThemeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteThemeMutation, DeleteThemeMutationVariables>(DeleteThemeDocument, options);
      }
export type DeleteThemeMutationHookResult = ReturnType<typeof useDeleteThemeMutation>;
export type DeleteThemeMutationResult = Apollo.MutationResult<DeleteThemeMutation>;
export type DeleteThemeMutationOptions = Apollo.BaseMutationOptions<DeleteThemeMutation, DeleteThemeMutationVariables>;
export const SetDefaultThemeDocument = gql`
    mutation SetDefaultTheme($themeId: String!, $environmentId: String!) {
  setDefaultTheme(input: {themeId: $themeId, environmentId: $environmentId}) {
    themes {
      ...ThemeDetail
    }
  }
}
    ${ThemeDetailFragmentDoc}`;

/**
 * __useSetDefaultThemeMutation__
 *
 * To run a mutation, you first call `useSetDefaultThemeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetDefaultThemeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setDefaultThemeMutation, { data, loading, error }] = useSetDefaultThemeMutation({
 *   variables: {
 *      themeId: // value for 'themeId'
 *      environmentId: // value for 'environmentId'
 *   },
 * });
 */
export function useSetDefaultThemeMutation(baseOptions?: Apollo.MutationHookOptions<SetDefaultThemeMutation, SetDefaultThemeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetDefaultThemeMutation, SetDefaultThemeMutationVariables>(SetDefaultThemeDocument, options);
      }
export type SetDefaultThemeMutationHookResult = ReturnType<typeof useSetDefaultThemeMutation>;
export type SetDefaultThemeMutationResult = Apollo.MutationResult<SetDefaultThemeMutation>;
export type SetDefaultThemeMutationOptions = Apollo.BaseMutationOptions<SetDefaultThemeMutation, SetDefaultThemeMutationVariables>;